import { FormattedMessage } from 'react-intl';
import { config, getAssetUrl, Provider } from '../../../../utils/config';
import Button from '../../../atoms/Button';
import './style.scss';

const ThirdPartySignIn = ({ providers, testIdPrefix }: { providers: Provider[]; testIdPrefix: string }) => (
  <div className="form__row auth-form__row">
    {providers.map(({ key, color }) => (
      <div className="form__field-container" key={key}>
        <Button
          type="button"
          className="provider"
          onClick={() => (window.location.href = `${config.apiHost}/auth/external/${key}`)}
          style={color ? { color, borderColor: color } : undefined}
          data-test-id={`${testIdPrefix}-${key}`}
        >
          <img src={getAssetUrl(`login/${key}.svg`)} alt={key} />
          <FormattedMessage id={`auth.continueWith${key.charAt(0).toUpperCase() + key.slice(1)}`} />
        </Button>
      </div>
    ))}
  </div>
);

export default ThirdPartySignIn;
